module.exports = __webpack_public_path__ + "img/r.54f29b3c.jpg";